import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M18.66 2C18.4 2 18.16 2.09 17.97 2.28L16.13 4.13L19.88 7.88L21.72 6.03C22.11 5.64 22.11 5 21.72 4.63L19.38 2.28C19.18 2.09 18.91 2 18.66 2ZM3.91852 4.64148C3.56611 4.28744 2.99322 4.28678 2.64 4.64V4.64C2.28678 4.99322 2.28744 5.56611 2.64148 5.91852L8.5 11.75L4.14645 16.1036C4.05268 16.1973 4 16.3245 4 16.4571V19.5C4 19.7761 4.22386 20 4.5 20H7.54289C7.6755 20 7.80268 19.9473 7.89645 19.8536L12.25 15.5L18.0815 21.3585C18.4339 21.7126 19.0068 21.7132 19.36 21.36V21.36C19.7132 21.0068 19.7126 20.4339 19.3585 20.0815L13.5 14.25L9.75 10.5L3.91852 4.64148ZM15.06 5.19L11.03 9.22L14.78 12.97L18.81 8.94L15.06 5.19Z" />
);

const smallIcon = (
  <path d="M12.44 1.33337C12.2667 1.33337 12.1067 1.39337 11.98 1.52004L10.9643 2.54124C10.8477 2.65849 10.848 2.848 10.9649 2.96493L13.0406 5.04067C13.158 5.15805 13.3484 5.15779 13.4655 5.04009L14.48 4.02004C14.74 3.76004 14.74 3.33337 14.48 3.08671L12.92 1.52004C12.7867 1.39337 12.6067 1.33337 12.44 1.33337ZM2.61234 3.09436C2.3774 2.85833 1.99548 2.85789 1.75999 3.09337V3.09337C1.52451 3.32886 1.52495 3.71078 1.76098 3.94572L5.66666 7.83337L2.81311 10.6869C2.71934 10.7807 2.66666 10.9079 2.66666 11.0405V13.0334C2.66666 13.1991 2.80098 13.3334 2.96666 13.3334H4.95955C5.09216 13.3334 5.21934 13.2807 5.31311 13.1869L8.16666 10.3334L12.0543 14.2391C12.2893 14.4751 12.6712 14.4755 12.9067 14.24V14.24C13.1421 14.0046 13.1417 13.6226 12.9057 13.3877L9 9.50004L6.5 7.00004L2.61234 3.09436ZM10.2521 3.67217C10.135 3.55502 9.94502 3.55502 9.82786 3.67217L7.35333 6.14671L9.85333 8.64671L12.3279 6.17217C12.445 6.05502 12.445 5.86507 12.3279 5.74791L10.2521 3.67217Z" />
);

export const EditOffIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="EditOff" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
